export default {
  en: {
    title: 'Log in to your account',
    email: 'Email Address',
    password: 'Password',
    login: 'Log in',
    forgot: 'Forgot Password?',
    remember: 'Remember me',
    errors: {
      email: 'Please enter your email',
      password: 'Please enter your password',
      incorrect: 'Please check your email or password.',
      subscriptions: 'You don\'t have an active subscriptions, please contact with us.',
      global: 'Server have a bad day, please try again.',
      level: 'Your account is of agent, please login in to console. Redirecting to your panel in 10 seconds.',
    },
    correct: 'Log in successful',
    logout: 'Session was closed successful',
  },
  es: {
    title: 'Ingrese a su cuenta',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    login: 'Acceder',
    forgot: '¿Olvidó su contraseña?',
    remember: 'Recordar este equipo',
    errors: {
      email: 'Ingrese su email',
      password: 'Ingrese su contraseña',
      incorrect: 'Revise su correo electrónico o contraseña.',
      subscriptions: 'No tiene suscripciones activas, contáctese con nosotros.',
      global: 'El servidor está pasando un mal día, inténtelo de nuevo.',
      level: 'Su cuenta es de agente, inicie sesión en la consola. Redireccionando a su panel en 10 segundos.',
    },
    correct: 'Ingreso correcto',
    logout: 'Sesión cerrada exitosamente',
  },
};
